module.exports = __webpack_public_path__ + "static/media/com-chart-for-website2022.122cc9eb.jpg";